import { DocumentType } from '../domain/types';
import { documentTypeLabels } from '../labels';
import { DocumentMetadata } from '../document/constants';
import { HYGRAPH_ASSET_BASE_URL } from '../providers/api/api';

export function noop() { }

export function getFormattedSeconds(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`;
}

export function rejectsNotImplemented() {
  return Promise.reject(new Error('Not implemented'));
}

export const raise = (err: string): never => {
  throw new Error(err);
};

export const sortDocumentsByLabel = (a: DocumentType, b: DocumentType) => documentTypeLabels[a].localeCompare(documentTypeLabels[b]);

export const sortDocumentsByOrderAndAlphabetically = <T extends DocumentType>(metadata: Record<T, DocumentMetadata>) => (a: T, b: T): number => {
  const aOrder = metadata[a]?.order || 0;
  const bOrder = metadata[b]?.order || 0;

  if (aOrder !== bOrder) {
    return aOrder - bOrder;
  }

  return documentTypeLabels[a].localeCompare(documentTypeLabels[b]);
};

/**
 * Rounds a number to a specified number of decimal places using HALF_UP rounding algorithm.
 * HALF_UP means if the next digit is >= 5, round up, otherwise round down.
 *
 * @param value - The number to round
 * @param decimals - The number of decimal places to round to (default: 2)
 * @returns The rounded number
 *
 * @example
 * roundHalfUp(493.76249, 2) // returns 493.76
 * roundHalfUp(493.765, 2) // returns 493.77
 */
export function roundHalfUp(value: number, decimals: number = 2): number {
  const multiplier = 10 ** decimals;
  return Math.round(value * multiplier) / multiplier;
}

export const getHygraphAssetUrl = (photoId: string): string => `${HYGRAPH_ASSET_BASE_URL}/${photoId}`;
